export default {
  API_URL: "https://api.xs2event.com/v1",
  STRAPI_API_URL: import.meta.env.VITE_STRAPI_API_URL || "https://cms.xs2event.com/api",
  strapiType: "Webpage",
  CDN_URL: "https://cdn.xs2event.com",
  ENV: "production",
  VERSION: "797f5a5b",
  SENTRY_ENABLE: true,
  SENTRY_DSN: "https://5ef4950df6ada99b85b943c142dc705e@sentry.xs2event.com/25",
  SENTRY_SAMPLE_RATE: 1.0,
  WEBAPP: "webpage3",
};
